import Component from "../classes/Component"

import Swiper from 'swiper';
import { Autoplay, Pagination} from 'swiper/modules';

export default class Carousel extends Component{
    constructor({element}){
        super({ element })

        this.carousel = {
            element: this.element,
        }

    }

    createCarousel = (entry) => {
        this.object = new Swiper(entry, {
            modules: [Autoplay, Pagination],
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 0,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            speed: 500,
            autoplay: {
                delay: 2000,
                disableOnInteraction: true,
                pauseOnMouseEnter: true,
            },
            // breakpoints: {
            //     834: {
            //         slidesPerView: 4,
            //         spaceBetween: 40,
            //     },
            // },

        });
    }

    onResize() {
        
    }
}